"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TIMEOUT = void 0;
var TIMEOUT = "timeout";
exports.TIMEOUT = TIMEOUT;
var prismicErrorHandle = function prismicErrorHandle(error, description) {
  if (error.message.includes("response timeout")) {
    return TIMEOUT;
  }
  console.log("".concat(description, " - ").concat(error));
  return false;
};
var _default = prismicErrorHandle;
exports["default"] = _default;